import { observer } from 'mobx-react-lite'
import { Table, TableSearch } from 'shared/ui/TableNew'
import { Box } from 'shared/ui'
import { useSurveysContext } from 'pages/surveys/context/surveysContext'
import { getSurveyRowActions } from 'pages/surveys/ui/actions'
import { surveysColumns } from './columns'

export const SurveysTable = observer(() => {
  const { tableStore, search, setSearch, items, scrollToTopTrigger, onDeleteItem } =
    useSurveysContext()

  const rows = items.map((item) => {
    item.setActionsProps({
      actions: getSurveyRowActions(item, onDeleteItem),
    })

    return item
  })
  return (
    <>
      <TableSearch value={search} onChange={setSearch} />
      <Box flexGrow={1}>
        <Table
          ariaLabel={'SurveysTable'}
          store={tableStore}
          columns={surveysColumns}
          rows={rows}
          emptyStateProps={{
            text: 'No results found',
          }}
          scrollToTOpTrigger={scrollToTopTrigger}
        />
      </Box>
    </>
  )
})
